export enum NotificationType {
  Error = 1,
  Success,
  Common,
}
